import { styled } from '@pata-app/themes';

export const TestimoninalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: ${({ theme }) => theme.core.sizing[5]}px;
  height: 100%;

  > div {
    h3 {
      margin-top: 0;
      margin-bottom: ${({ theme }) => theme.core.sizing[1]}px;
      font-size: ${({ theme }) => theme.core.fontSizes.xl}px;
    }
    p {
      margin: 0;
      margin-top: ${({ theme }) => theme.core.sizing[0]}px;

      font-size: ${({ theme }) => theme.core.fontSizes.l}px;
      font-family: ${({ theme }) => theme.core.fontFamily.jost};
      justify-self: center;
    }
  }

  > p {
    margin: 0;

    color: ${({ theme }) => theme.core.colors.greyscale.dark};
    grid-column: 1 / span 2;

    align-self: flex-end;
  }

  img {
    align-self: center;

    border-radius: ${({ theme }) => theme.core.border.element.radius}px;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.xl}`} {
    padding: ${({ theme }) => theme.core.sizing[5]}px;

    display: grid;
    grid-template-columns: min-content auto;
    grid-template-columns: min-content auto;
    column-gap: ${({ theme }) => theme.core.sizing[4]}px;
    row-gap: ${({ theme }) => theme.core.sizing[2]}px;
  }
`;
